<template>
    <div>
        <template v-if="loading">
            <div class="text-h5 px-3">
                
               {{ payResult ? 'Обработка платежа...' : 'Получение сведений о платеже' }} 
            
            </div>
            <sg-loader :loading="true" />
        </template>

        <template v-else>

            <template v-if="wrongStatus">


                <div class="px-3">

                    <div class="text-h5 pb-2">Некорректный платеж</div>

                    В вашим платежом что-то не так, свяжитесь с технической поддержкой, сообщив номер платежа.

                    Номер платежа:

                    <v-sheet class="py-2 px-0 my-3" color="grey lighten-3">

                        <div class="d-flex align-center">

                            <v-text-field ref="unp" readonly class="px-0" :value="payResult.unp" hide-details solo flat
                                background-color="transparent">



                            </v-text-field>

                            <v-btn icon class="mx-3" @click="copyUnp">
                                <v-icon>
                                    mdi-clipboard
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-sheet>

                    <v-divider class="my-3" />

                </div>
                <sg-quick-pay-support />

            </template>

            <template v-else-if="hasError">

                <div class="px-3">

                    <div class="text-h5 pb-2">Ошибка</div>

                    Сбой при попытке получить информацию о платеже
                    <v-divider class="my-3" />

                </div>

                <sg-quick-pay-support />

            </template>

            <template v-else>


                <div class="text-h5 green--text pb-2 px-3">Платёж выполнен!</div>

                <sg-quick-signup v-if="!payResult.registered" :pre-phone="phone" />

                <v-list-item v-if="!payResult.registered">

                    <v-list-item-icon>
                        <v-icon>mdi-information</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <!--         <v-list-item-subtitle class="grey--text">Наименование</v-list-item-subtitle> -->
                        <v-list-item-title>Подробнее</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn icon @click="showDetails = !showDetails">
                            <v-icon :class="{'sg-rotate': showDetails}">mdi-chevron-down</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>

                <v-expand-transition>
                    <div v-show="showDetails">

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle class="grey--text">Наименование</v-list-item-subtitle>
                                <v-list-item-title>Оплата квитанции</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider />

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle class="grey--text">Лицевой счет</v-list-item-subtitle>
                                <v-list-item-title>{{payResult.account}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>


                        <v-divider />

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle class="grey--text">Период</v-list-item-subtitle>
                                <v-list-item-title>{{formattedPeriod}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>


                        <v-divider />

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-subtitle class="grey--text">Номер платежа</v-list-item-subtitle>
                                <v-list-item-title>{{payResult.unp}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-expand-transition>
                <!--   </div> -->

            </template>

        </template>

    </div>
</template>

<script>
    import SgQuickPay from './SgQuickPay'
    import SgQuickSignup from './SgQuickSignup'
    import SgQuickPaySupport from './SgQuickPaySupport'

    /*     import SgQuickPayContent from './SgQuickPayContent' */

    export default {
        name: 'sg-quick-pay-status',

        components: {
            SgQuickPay,
            SgQuickSignup,
            SgQuickPaySupport,
            /*            SgQuickPayContent */
        },

        beforeDestroy() {
            this.clearTimer()
        },

        computed: {
            phone() {
                return this.payResult.phone
            },
            hasPhone() {
                return !!this.phone
            },
            /*           successMessage() {
                          return `Счет №${this.payResult.unp} по л/с ${this.payResult.account} за ${this.formattedPeriod} оплачен!`
                      }, */
            formattedPeriod() {
                return this.formatPeriod(this.payResult.period)
            }
        },

        data() {
            return {
                loading: true,
                timer: null,
                payResult: null,
                hasError: false,
                /*      showAlert: true, */
                wrongStatus: false,


                showDetails: true
            }
        },

        methods: {

            formatPeriod(period) {
                let str = period.toString()
                let monthNumber = str.substr(0, 2)
                let year = str.substr(2, 4)
                return `${this.getMonthName(monthNumber)} ${year}`
            },

            getMonthName(monthNumber) {

                let num = Number.parseInt(monthNumber)

                switch (num) {
                    case 1:
                        return 'Январь'
                    case 2:
                        return 'Февраль'
                    case 3:
                        return 'Март'
                    case 4:
                        return 'Апрель'
                    case 5:
                        return 'Май'
                    case 6:
                        return 'Июнь'
                    case 7:
                        return 'Июль'
                    case 8:
                        return 'Август'
                    case 9:
                        return 'Сентябрь'
                    case 10:
                        return 'Октябрь'
                    case 11:
                        return 'Ноябрь'
                    case 12:
                        return 'Декабрь'
                }


            },

            copyUnp() {
                this.$refs.unp.$refs.input.select()
                document.execCommand("copy");

                this.$eventBus.$emit('snackbar:open', {
                    message: 'Номер платежа скопирован!',
                    props: {
                        top: !this.isMobile
                    }
                })

            },

            validatePayStatus(payStatus) {
                switch (payStatus) {
                    case "NOT_FOUND":
                        return false;
                    case "DELETED":
                        return false;
                    case "STORNED":
                        return false;
                    case "STORNO":
                        return false;
                    case "SAVED":
                        return true;
                    case "AUTH":
                        return true;
                    case "ERROR_STATUS":
                        return false;
                    default:
                        return false;
                }
            },


            clearTimer() {
                if (this.timer) {
                    clearTimeout(this.timer)
                    this.timer = null
                }
            },

            startTimer() {

                this.clearTimer()

                this.timer = setTimeout(() => {

                    this.getPaymentStatus()

                }, 1000)
            },

            getPaymentStatus() {

                let unp = this.$route.params.unp

                this.loading = true

                this.$logger.log('request getPaymentStatus unp: ', unp)

                this.$api.getPaymentStatus(unp)
                    .then(res => {
                        this.$logger.log('getPaymentStatus: ', res)

                        if (!this.validatePayStatus(res.payStatus)) {
                            this.wrongStatus = true
                            this.payResult = res
                            this.loading = false
                            return
                        }

                        switch (res.payStatus) {
                            case 'AUTH': {
                                this.payResult = res
                                this.loading = false
                                break;
                            }
                            case 'SAVED': {
                                this.startTimer()
                                break;
                            }
                        }
                    })
                    .catch(error => {
                        this.$logger.error('getPaymentStatus: ', error)
                        this.hasError = true
                        this.loading = false
                    })
            }
        },
        mounted() {



            this.getPaymentStatus()
        }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active до версии 2.1.8 */
        {
        opacity: 0;
    }

    .sg-rotate {
        transform: rotate(180deg)
    }
</style>